@let hasMultipleElements = ((layoutService.elements$ | async)?.length ?? 0) > 1;
@let selectedLayout = layoutService.layout$ | async;
@if (hasMultipleElements) {
  <div class="layouts">
    @for (layout of layouts; track layout) {
      @if (hasMultipleElements) {
        <button
          mat-button
          (click)="layoutService.setLayout(layout)"
          [class.active]="selectedLayout === layout"
          [matTooltip]="getLayoutTooltip(layout)"
        >
          <svg [lucideIcon]="getLucideForLayout(layout)"></svg>
        </button>
      }
    }
  </div>
}
